export class KYMW1310MultiPublishListModel {
  // 媒体コード
  public mediumType: string = <string>'';
  // 媒体名
  public mediumName: string = <string>'';
  // 全生協
  public publishFlagALL: boolean = <boolean>false;
  // 掲載フラグ（い）
  public publishFlagIB: boolean = <boolean>false;
  // 掲載フラグ（と）
  public publishFlagTO: boolean = <boolean>false;
  // 掲載フラグ（ぐ）
  public publishFlagGU: boolean = <boolean>false;
  // 掲載フラグ（ち）
  public publishFlagTI: boolean = <boolean>false;
  // 掲載フラグ（さ）
  public publishFlagSA: boolean = <boolean>false;
  // 掲載フラグ（とう）
  public publishFlagTK: boolean = <boolean>false;
  // 掲載フラグ（な）
  public publishFlagNA: boolean = <boolean>false;
  // 掲載フラグ（に）
  public publishFlagNI: boolean = <boolean>false;
  // 掲載フラグ（ク）
  public publishFlagKU: boolean = <boolean>false;
}
